import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
  selector: 'app-set-reminder-dialog',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, MatDialogModule, MatDatepickerModule,
    MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, MatNativeDateModule
  ],
  template: `
    <div class="sm:w-120 md:w-140">
      <h2 mat-dialog-title class="flex items-center">
          <mat-icon svgIcon="tabler_outline:calendar-plus" class="mr-2"></mat-icon>
          Set Reminder Date
      </h2>
      <div mat-dialog-content class="pt-4">
          <mat-form-field class="w-full" (click)="picker.open()">
              <mat-label>Reminder Date</mat-label>
              <input matInput [matDatepicker]="picker" [formControl]="dateCtrl" [min]="minDate">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
      </div>
      <div mat-dialog-actions class="justify-between">
          <button mat-button color="warn" (click)="remove()">Reset</button>
          <div>
              <button mat-button mat-dialog-close>Cancel</button>
              <button mat-flat-button color="primary" (click)="save()" [disabled]="dateCtrl.invalid">Save reminder</button>
          </div>
      </div>
    </div>
    
  `
})
export class SetReminderDialogComponent {
  dateCtrl: FormControl;
  minDate: Date;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { currentDate: Date | null },
    private _dialogRef: MatDialogRef<SetReminderDialogComponent>
  ) {
    this.dateCtrl = new FormControl(data.currentDate);
    this.minDate = new Date();
  }

  save(): void {
    // Close and return the selected date
    this._dialogRef.close(this.dateCtrl.value);
  }

  remove(): void {
    // Close and return null to signify removal
    this._dialogRef.close(null);
  }
}